import React from 'react';

const DocumentHead = () => {
  return <></>;
};

export default DocumentHead;
